import styles from '../../styles.module.less';
import { useIntl } from 'react-intl';
import { getPeriodEmptyUserDataText } from '@src/containers/App/TimeTracker/Main/utils/getPeriodEmptyUserDataText';

const PeriodEmptyUserData = ({ startDate, endDate, queriedPeriod = '' }) => {
  const intl = useIntl();

  return (
    <h3 className={styles.emptyUserData}>
      <span>{getPeriodEmptyUserDataText(intl, startDate, endDate, queriedPeriod)}</span>
    </h3>
  );
};

export default PeriodEmptyUserData;
